export const ID_CLASSIFICATION_TABLE_HEADER = 1;
export const ID_CLASSIFICATION_TABLE_BODY_CELL = 2;
export const ID_CLASSIFICATION_OUTSIDE_TABLE = 3;
export const ID_CLASSIFICATION_SIGNATURE = 4;
export const ID_CLASSIFICATION_EMBEDDING = 5;
